import { Grid } from '@material-ui/core';
import React from 'react';
import Card from '../../components/Card/Card.component';
import { IBar } from '../../models/IBars';
import { IReport } from '../../models/IReport';
import Label from '../Label/Label.component';

interface Props {
    data: IReport
}

export default function BarReports({
    data
}: Props) {
    return (
        <Card>
            <Grid container>
                {/* <Grid xs={12} md={3} lg={2} item>
                    <Label bold>
                        Inventory Size:
                    </Label>
                </Grid>
                <Grid xs={12} md={9} lg={10} item>
                    <Label>
                        {data?.inventorySize}
                    </Label>
                </Grid> */}
                <Grid xs={12} md={3} lg={2} item>
                    <Label bold>
                        Total Points given:
                    </Label>
                </Grid>
                <Grid xs={12} md={9} lg={10} item>
                    <Label>
                        {data?.totalPointsGiven}
                    </Label>
                </Grid>
                <Grid xs={12} md={3} lg={2} item>
                    <Label bold>
                        Total Rewards given:
                    </Label>
                </Grid>
                <Grid xs={12} md={9} lg={10} item>
                    <Label>
                        {data?.totalrewardsGiven}
                    </Label>
                </Grid>
            </Grid>
        </Card>
    )
}
